"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var HorizontalScroll_less_1 = __importDefault(require("./HorizontalScroll.less"));
var SCROLL_THRESHOLD = 1;
var HorizontalScroll = function (_a) {
    var className = _a.className, children = _a.children;
    var ref = (0, react_1.useRef)(null);
    var _b = (0, react_1.useState)('left'), scrollPosition = _b[0], setScrollPosition = _b[1];
    (0, react_1.useEffect)(function () {
        var onScroll = function (_a) {
            var target = _a.target;
            var _b = target, scrollLeft = _b.scrollLeft, scrollWidth = _b.scrollWidth, offsetWidth = _b.offsetWidth;
            setScrollPosition(function () { return ((scrollLeft - SCROLL_THRESHOLD) <= 0 ? 'left' :
                (scrollLeft + offsetWidth + SCROLL_THRESHOLD) >= scrollWidth ? 'right' :
                    'center'); });
        };
        var el = ref.current;
        if (!el)
            return;
        var onFocusIn = function (event) {
            var target = event.target;
            if (!target)
                return;
            if (!el.contains(target))
                return;
            requestAnimationFrame(function () {
                target.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
            });
        };
        el.addEventListener('scroll', onScroll);
        el.addEventListener('focusin', onFocusIn);
        return function () {
            el.removeEventListener('scroll', onScroll);
            el.removeEventListener('focusin', onFocusIn);
        };
    }, []);
    return (react_1.default.createElement("div", { ref: ref, className: (0, classnames_1.default)(HorizontalScroll_less_1.default['horizontal-scroll'], className, [HorizontalScroll_less_1.default[scrollPosition]]) }, children));
};
exports.default = HorizontalScroll;
